const APP_CONSTANTS = {
  // App Config
  APP_CONFIG: 'appConfig',
  APP_CONSENT: 'appConsent',
  SHOPMODE: 'shopmode',
  FEATURES: 'FEATURES',
  RETURN_ROUTE: 'RETURN_ROUTE',
  SCOPE: 'SCOPE',
  FILTERS: 'FILTERS',

  // App Pending (for App Spinner)
  APP_PENDING: 'APP_PENDING',

  // PAGE
  PAGE_TITLE: 'PAGE_TITLE',
  ROUTE_TITLE: 'ROUTE_TITLE',

  // LINKS
  LINKS: 'links',
  LOGOUT_URL: 'logoutUrl',
  RETURN_API_URL: 'returnApiUrl',
  MESSAGE_STATUS_URL: 'MESSAGE_STATUS_URL',
  BLOCKINGREASON_URL: 'blockingreason',
  PAYMENT_TERMS_URL: 'paymentTerms',
  SDGP_API_URL: 'sgdpApiUrl',
  USERMANAGEMENT_URL: 'usermanagement',
  MULEAPISERVICE_URL: 'muleapiservice',
  RMA_OVERVIEW_PAGE_URL: 'rmaOverviewPage',
  CONNECTED_BIKE_MANUAL_URL: 'connectedBikeManualPage',
  ADMIN_URL: 'admin',
  ENVIRONMENT: 'environment',
  ENVIRONMENT_TYPO3: 'environmentTypo3',
  ENVIRONMENT_DATA: 'ENVIRONMENT_DATA',
  ENGINE_COMPLAINT_FORM_URL: 'engineComplaintFormUrl',
  ENGINE_COMPLAINT_FORM_TITLE: 'engineComplaintFormTitle',
  ENGINE_COMPLAINT_WORKTIME_FORM_URL: 'engineComplaintWorktimeFormUrl',
  BATTERY_CHARGER_COMPLAINT_FORM_URL: 'batteryChargerComplaintFormUrl',
  SERVICE_WARRANTY_PAGE_URL: 'serviceWarrantyPageUrl',
  PAY_NOW_TICKET_URL: 'payNowTicketUrl',
  DEBIT_CHARGE: 'debitCharge',
  CAN_ISSUE_SEPA_MANDATES: 'canIssueSepaMandates',
  EVENT_COUNT: 'eventCount',
  EMAIL: 'email',
  BACKORDER_PAGE_URL: 'backorder',

  // Portal Targets
  PORTAL_TARGETS: 'portalTargets',

  // Logout State
  LOGOUT_STATE: 'setLogoutState',

  // Initial countdown time for logging out
  COUNTDOWN_LOGOUT_TIME: 'logoutTime',

  // Polling Interval
  POLLING_INTERVAL_MINUTES: 'pollingIntervalMinutes',

  // Current Logout time
  CURRENT_LOGOUT_TIME: 'currentLogoutTime',

  // Overlay
  OVERLAY_IS_VISIBLE: 'overlayIsVisible',

  // Basket
  BASKET_IS_VISIBLE: 'basketIsVisible',

  // Navigation
  DRAWER_IS_VISIBLE: 'drawerIsVisible',
  APP_BAR_IS_HIDDEN: 'APP_BAR_IS_HIDDEN',

  // Search
  // TODO: Refactor to an object in store
  // SEARCH: 'search',
  // SEARCH_DIALOG_IS_VISIBLE: 'searchDialogIsVisible', // ToDo: Remove
  // SEARCH_QUERY: 'searchQuery', // ToDo: Remove
  // SEARCH_SELECTION: 'searchSelection',
  // SEARCH_PAGE: 'searchPage', // ToDo: Remove
  // SEARCH_URL: 'searchUrl', // ToDo: Remove
  // SEARCH_QUERY_MIN_LENGTH: 'searchQueryMinLength', // ToDo: Remove
  SEARCH_IMMEDIATE: 'searchImmediate',
  // SEARCH_IS_OVERVIEW: 'searchIsOverview', // ToDo: Remove
  // SEARCH_PARAMS: 'SEARCH_PARAMS',
  // SEARCH_SKU: 'SEARCH_SKU',
  // CATEGORIES: 'CATEGORIES',

  // Product List
  PRODUCT_VIEW: 'productView',
  PRODUCT_VIEW_TYPE: {
    LIST: 'list',
    GRID: 'grid',
  },

  // Browser
  BROWSER_IS_SAFARI: 'BROWSER_IS_SAFARI',

  // Dimensions
  DIMENSIONS: 'dimensions',
  WIDTH: 'WIDTH',
  HEIGHT: 'HEIGHT',
  SHOW_SCROLL_TO_TOP: 'showScrollToTop',

  // Language
  LOCALE: 'LOCALE',
  TWO_LETTER_LOCALE: 'TWO_LETTER_LOCALE',

  // My account
  MY_ACCOUNT_CURRENT_TAB: 'MY_ACCOUNT_CURRENT_TAB',

  // Help Path
  HELP_PATH: 'HELP_PATH',

  // HELP return value
  RETURN_FROM_HELP: 'RETURN_FROM_HELP',

  // User
  USER: 'user',
  CUSTOMER_NUMBER: 'customerNumber',
  USERNAME: 'username',
  SUBUSER: 'subUser',
  SUPPORT_USER: 'supportUser',
  SUBUSER_TYPE: {
    STANDARD: 'standard',
    GUEST: 'guest',
  },
  SITE_ATTRIBUTES: 'siteAttributes',
  USER_BRANDS: 'brands',
  USER_GROUPS: 'groups',
  USER_COMPANIES: 'customer_clients',
  USER_CLIENTS: 'clientIds',
  USER_CURRENCY: 'currency',
  CUSTOMER_COUNTRYID: 'CUSTOMER_COUNTRYID',
  CUSTOMER_LANGUAGEID: 'CUSTOMER_LANGUAGEID',
  CUSTOMER_FIRSTNAME: 'CUSTOMER_FIRSTNAME',
  CUSTOMER_LASTNAME: 'CUSTOMER_LASTNAME',
  CUSTOMER_TELEPHONE: 'CUSTOMER_TELEPHONE',
  PAGE_TITLE_ENGLISH: 'englishPageTitle',

  // Notifications
  // NOTIFICATION_OPEN_DELAY: 2500, // milliseconds
  // NOTIFICATION_MESSAGE_OPEN: 'NOTIFICATION_MESSAGE_OPEN',
  // NOTIFICATION_MESSAGE: 'NOTIFICATION_MESSAGE',
  // NOTIFICATION_MESSAGE_TYPE: 'NOTIFICATION_MESSAGE_TYPE',
  // NOTIFICATION_TYPES: {
  //   WARNING: 'warning',
  //   INFO: 'info',
  //   ERROR: 'error',
  //   SUCCESS: 'success',
  // },
  NOTIFICATIONS: 'NOTIFICATIONS',

  // LaunchPortal
  LAUNCH_PORTAL: 'launchPortal',
  // News
  NEWS_UNREAD: 'NEWS_UNREAD',

  PAYMENT_TERMS: 'PAYMENT_TERMS',
  // SelectedBrand
  SELECTED_BRAND: 'SELECTED_BRAND',
}

export default APP_CONSTANTS

export const SETS = {
  SUPPORT_ACCESS: 'SupportAccess',
}

export const SET_CONFIGS = {
  [SETS.SUPPORT_ACCESS]: {
    defaultUrl: {
      REQUEST: 'https://usermanagement.service.focus-kalkhoff-dealer.com/api/support-token', // TODO: Use env variable
    },
    defaultData: {
      REQUEST: { endpoint: 'get' },
    },
  },
}
